import { render, staticRenderFns } from "./Ga.vue?vue&type=template&id=53500e22&"
import script from "./Ga.vue?vue&type=script&lang=js&"
export * from "./Ga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports